var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"close--button"},[_c('base-button',{attrs:{"backgroundColor":"bb-primary","text":_vm.$t('done')},on:{"click":function($event){return _vm.closeModal()}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }